import * as angular from "angular";

export class ProNumberDialogService {

  constructor(private $mdDialog) {
  }

  editProNumberDialog(proNumber: string, isProNumberRequired?: boolean) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/edit-pro-number-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, deliveriesConstants) {

        $scope.proNumber = angular.copy(proNumber);
        $scope.cancel = self.$mdDialog.cancel;
        $scope.isProNumberRequired = isProNumberRequired;
        ///////////////////////////////////////////////////////////


        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.proNumber);
            }
          }
        }

      },
    })
  }


}

angular
  .module('bringoz.admin.commons')
  .service('proNumberDialogService', ProNumberDialogService);

